import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const FormFieldsWrapper = styled.div`
  width: 50%;
  position: relative;
`

export const PasswordChecksWrapper = styled.div`
  margin-top: ${Spacing.S8};
`
